import Model, { attr, hasMany } from "@ember-data/model";
import type CompoundSurvey from "./compound-survey";

export default class CompoundQuestion extends Model {
  @attr("string") declare label: string;

  @attr({
    defaultValue() {
      return [];
    }
  })
  declare answers: string[];

  @hasMany("compound-survey", {
    async: false,
    inverse: "questions"
  })
  declare surveys: CompoundSurvey[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "compound-question": CompoundQuestion;
  }
}
